import React from 'react';
import { useTranslation } from 'react-i18next';

const RoleplayServersSection = () => {
  const { t } = useTranslation();

  const servers = [
    {
      id: 'forasteros',
      title: t('servers.forasteros.title'),
      description: t('servers.forasteros.description'),
      image: '/images/servers/forasteros.png',
      platform: 'FiveM',
      status: 'Histórico',
      year: '2019-2022'
    },
    {
      id: 'oasis',
      title: t('servers.oasis.title'),
      description: t('servers.oasis.description'),
      image: '/images/servers/oasis.png',
      platform: 'FiveM',
      status: 'Histórico',
      year: '2021'
    },
    {
      id: 'avalon',
      title: t('servers.avalon.title'),
      description: t('servers.avalon.description'),
      image: '/images/servers/avalon.png',
      platform: 'Minecraft',
      status: 'Histórico',
      year: '2021-2022'
    },
    {
      id: 'hermandad',
      title: t('servers.hermandad.title'),
      description: t('servers.hermandad.description'),
      image: '/images/servers/hermandad.png',
      platform: 'Red Dead Redemption 2',
      status: 'Colaboración',
      year: '2021-Presente'
    },
    {
      id: 'overlife',
      title: t('servers.overlife.title'),
      description: t('servers.overlife.description'),
      image: '/images/servers/overlife.png',
      platform: 'FiveM',
      status: 'Histórico',
      year: '2022'
    },
    {
      id: 'london_eye',
      title: t('servers.london_eye.title'),
      description: t('servers.london_eye.description'),
      image: '/images/servers/london-eye.png',
      platform: 'FiveM',
      status: 'Histórico',
      year: '2022'
    },
    {
      id: 'nopixel_espana',
      title: t('servers.nopixel_espana.title'),
      description: t('servers.nopixel_espana.description'),
      image: '/images/servers/nopixel-espana.png',
      platform: 'FiveM',
      status: 'Activo',
      year: '2022-Presente'
    }
  ];

  return (
    <section className="roleplay-servers">
      <div className="container">
        <h2 className="section-title">{t('servers.title')}</h2>
        <p className="text-center mb-2" style={{ color: '#cccccc', fontSize: '1.2rem' }}>
          {t('servers.subtitle')}
        </p>
        <div className="servers-grid">
          {servers.map((server) => (
            <div className="server-card" key={server.id}>
              <div className="server-image-container">
                <img
                  src={server.image}
                  alt={server.title}
                  className="server-image"
                />
                <div className="server-overlay">
                  <span className={`server-status ${server.status.toLowerCase().replace(' ', '-')}`}>
                    {server.status}
                  </span>
                  <span className="server-platform">{server.platform}</span>
                </div>
              </div>
              <div className="server-content">
                <h3>{server.title}</h3>
                <p className="server-year">{server.year}</p>
                <p>{server.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoleplayServersSection;
